export const showFormInputError = (element, message) => {
  let event = new CustomEvent("gp-input-error", {
    bubbles: true,
    detail: { show: true, errorMessage: message }
  });

  element.dispatchEvent(event);
};

export const hideFormInputError = (element) => {
  let event = new CustomEvent("gp-input-error", {
    bubbles: true,
    detail: { show: false }
  });

  element.dispatchEvent(event);
};

export const toggleFormInputError = (show, element, message) => {
  show ? showFormInputError(element, message) : hideFormInputError(element);
};
